import styled from 'styled-components'
import Container from '../container/index'
import globals from '../globals'
import { H2, H5 } from '../headings/index'
import BackgroundShape from '../../images/background-shape.png'
import BackgroundGradient from '../../images/background-home.jpg'

export const EtapasGrid = styled.div`
  display:grid;
  max-width: ${props => props.maxWidth ? `${props.maxWidth}px` : '1000px'};
  margin:0 auto;
  /* grid-template-columns: repeat(3, minmax(0, 1fr)); */
  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
  grid-gap:35px;

  @media ${globals.mediaqueries.extraSmall}{
    grid-template-columns: 1fr;
  }

  @media ${globals.mediaqueries.small}{
    grid-template-columns: 1fr;
  }
`

export const EtapasWrapper = styled(Container)`
  margin-top:80px;
  margin-bottom:95px;

  @media ${globals.mediaqueries.small}{
    margin-bottom:50px;
  }

  @media ${globals.mediaqueries.extraSmall}{
    margin-bottom:40px;
  }

  h2, h3 {
    color: #131149;
  }
  
  h2 {
    text-align: center;
    margin-bottom:70px;
    
    &.margin-bottom-50 {
      margin-bottom: 50px;
    }
  }
  
  .support-text {
    font-size: 18px;
    font-family: Roboto,sans-serif;
    margin-bottom: 70px;
    text-align: center;
    font-weight: 300;
    color: #113c64;
  }
`

export const Etapa = styled.div`
  display:grid;
  grid-template-columns: 70px minmax(0, 1fr);
  grid-gap: 30px;
  font-weight:300;
  color: ${globals.colors.darkblue};

  & > div {
    align-self: ${props => props.centerText ? 'center' : 'auto'};

    h3 {
      margin-bottom: ${props => props.centerText ? '0' :'1.45rem'};
    }
  }

  p {
    line-height:1.6;

    a {
      color: ${globals.colors.darkblue};

      &:hover {
        text-decoration: none;
      }
    }
  }
`

export const EtapaImageWrapper = styled.div`
  width:70px;
  height:70px;
  display: block;
  border-radius:50%;
  position: relative;
  box-shadow: 0 5px 16px 0 rgba(121,105,230,0.15);
  display:flex;
  text-align:center;
  margin:0 auto;
  background: ${props => props.bgColor ? props.bgColor : 'transparent'};

  img {
    max-height:35px;
    align-self: center;
    margin:0 auto;
  }
`

export const FormasWrapper = styled.div`
  position: relative;

  .screenshot {
    max-width: 50vw;

    @media ${globals.mediaqueries.small}{
      max-height:300px;
    }
    @media ${globals.mediaqueries.extraSmall}{
      max-height:300px;
    }
  }
`

export const ContainerFormas = styled(Container)`
  width:100%;
  height: 100%;
  position: absolute;
  left:50%;
  top:50%;
  transform: translate3d(-50%, -50%, 0);
  display:grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap:50px;

  @media ${globals.mediaqueries.small}{
    transform: translate3d(0, 0, 0);
    grid-template-columns: minmax(0, 1fr);
    grid-gap:15px;
    left:auto;
    top:auto;
    position: relative;
  }

  @media ${globals.mediaqueries.extraSmall}{
    transform: translate3d(0, 0, 0);
    grid-template-columns: minmax(0, 1fr);
    grid-gap:15px;
    left:auto;
    top:auto;
    position: relative;  
  }
`

export const FormasTextos = styled.div`
  align-self:center;
  padding-left:66px;

  @media ${globals.mediaqueries.small}{
    padding-left:0;
  }
  @media ${globals.mediaqueries.extraSmall}{
    padding-left:0;
  }

  h2 {
    color: ${globals.colors.darkblue};
  }

  h5 {
    color: ${globals.colors.lightblue};

    @media ${globals.mediaqueries.small}{
      margin-top:50px;
    }
    @media ${globals.mediaqueries.extraSmall}{
      margin-top:40px;
    }
  }

  p {
    line-height:1.6;
    color: ${globals.colors.darkblue};
  }
`

export const FormasBlockWrapper = styled.div`
  align-self:flex-end;
`

export const FormasBlock = styled.div`
  background:${globals.colors.darkblue};
  box-shadow: -8px -8px 0 0 white;
  max-width:286px;
  margin-right: 0;
  margin-left: auto;
  transform: translateX(55px);
  color: #abaae6;
  padding: 20px;

  @media ${globals.mediaqueries.small}{
    transform: translateX(0);
    position:absolute;
    right:0;
    top:-280px;
  }

  @media ${globals.mediaqueries.extraSmall}{
    transform: translateX(0);
    position:absolute;
    right:0;
    top:-280px;
  }

  h5 {
    color:white;
    margin: 0 0 .7em 0;
  }

  p {
    font-size:15px;
    line-height:1.35;
  }

  img {
    margin:0;
  }
`

export const ScreenshotsWrapper = styled.div`
  background:url(${BackgroundShape}) no-repeat center top 90px;
  background-size:100% calc(100% - 90px);
  position:relative;
  text-align: center;
  padding: 140px 0 200px;

  @media ${globals.mediaqueries.huge}{
    background-size: 100% 100%;
  }

  & > div {
    margin:0 auto;
    width:100%;
    display:block;
    max-width:420px;
    
    @media ${globals.mediaqueries.small}{
      padding-left:${globals.paddingSides.small};
      padding-right:${globals.paddingSides.small};
    }
    @media ${globals.mediaqueries.extraSmall}{
      padding-left:${globals.paddingSides.small};
      padding-right:${globals.paddingSides.small};
    }

    & > div {
      margin-bottom:25px;

      & > img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    h2 {
      color: ${globals.colors.darkblue};
    }

    p {
      font-weight:300;
      line-height: 1.6;
    }
  }

  .img-left, .img-right {
    position: absolute;
    max-width:35vw;
    margin:0;
  }

  .img-left {
    left:0;
    top:0;

    @media ${globals.mediaqueries.small}{
      top:60px;
      z-index:-1;
    }
    @media ${globals.mediaqueries.extraSmall}{
      top:60px;
      z-index:-1;
    }
  }

  .img-right {
    right:0;
    bottom:0;

    @media ${globals.mediaqueries.extraSmall}{
      max-width:35vw;
      bottom: 60px;
      z-index:-1;
    }

    @media ${globals.mediaqueries.small}{
      max-width:35vw;
      bottom: 10px;
      z-index:-1;
    }
  }
`

export const CarouselWrapper = styled.div`
  position: relative;
  padding-bottom: 30px;
  margin:0 auto;
  max-width:1000px;

  .react-multi-carousel-dot button {
    width: 7px;
    height: 7px;
    border: none;
    background: #3a3864;
  }

  .react-multi-carousel-dot--active button {
    background: ${globals.colors.lightblue};
  }

  .react-multi-carousel-dot-list  {
    
    li {
      margin:0;
    }
  }
`

export const ControleCobrancasWrapper = styled.div`
  display:grid;
  position: relative;
  margin-top:50px;
  margin-bottom:50px;

  img {
    margin-right:0;
    margin-left:auto;
    max-width:66vw;

    @media ${globals.mediaqueries.small}{
      max-width: unset;
      width: 100%;
      height: auto;
    }
    @media ${globals.mediaqueries.extraSmall}{
      max-width: unset;
      width: 100%;
      height: auto;
    }
  }

  & > div {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%,-50%,0);

    @media ${globals.mediaqueries.small}{
      position:relative;
    }
    @media ${globals.mediaqueries.extraSmall}{
      position:relative;
    }
  }
`

export const ControleCobrancasText = styled.div`
  max-width:500px;

  h2 {
    color: ${globals.colors.darkblue};
  }

  h5 {
    color: ${globals.colors.lightblue};
  }

  p {
    line-height:1.6;
    font-weight:300;
  }
`

export const DepoimentosWrapper = styled(Container)`
  display:grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap:35px;
  margin-top: 80px;
  margin-bottom: 80px;
`

export const DepoimentoSingle = styled.div`
  text-align: center;
  color: ${globals.colors.darkblue};

  img {
    border-radius:50%;
    margin:0 auto;
  }

  h5 {
    margin:15px 0 5px;
  }

  blockquote {
    font-style: italic;
    line-height:1.6;
    font-weight:300;
  }
`

export const PostsTitleWrapper = styled.div`
  text-align: center;

  img {
    display:block;
    margin:0 auto;
  }

  h2 {
    color: ${globals.colors.darkblue};
  }
`

export const PostLink = styled.a`
  display: block;
  background:#f5f9fc;
  padding:4px;
  text-decoration: none;

  &:hover {

    img {
      opacity:0.8;
    }
  }

  img {
    width:100%;
    height:auto;
    display:block;
    margin:0;
    transition: all .2s;
  }

  & > div {
    padding: 20px 15px;
  }

  time, p {
    font-size:13px;
    font-weight: 300;
    display: block;
    color: ${globals.colors.lightblue};
  }

  time {    
    margin-bottom:10px;
  }

  h6 {
    margin:0 0 10px 0;
    color: ${globals.colors.darkblue};
    overflow:hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;  
  }
`

export const InternalHeader = styled.div`
  text-align: center;
  padding-top:60px;
  padding-bottom:60px;

  @media ${globals.mediaqueries.extraSmall}, ${globals.mediaqueries.small}{
    padding-top:40px;
    padding-bottom:40px;
  }

  h1 {
    color: ${globals.colors.darkblue};

    span {
      font-weight:800
    }
  }

  p {
    color:#666;
    line-height:1.6;
    max-width:950px;
    font-weight:300;
    margin:0 auto;
  }
`

export const BlueWrapper = styled.div`
  padding-bottom: 45%;
  height: 0;
  width: 100%;
  position: relative;
  background: url(${BackgroundGradient}) no-repeat center top;
  background-size: 100% 100%;
  -webkit-clip-path: url(#slider-desktop-clip-path);
  clip-path: url(#slider-desktop-clip-path);

  @media ${globals.mediaqueries.extraSmall}{
    padding-bottom:0;
    height:380px;
    background-size: auto 100%;
  }

  @media ${globals.mediaqueries.small}{
    padding-bottom:0;
    height:380px;
    background-size: auto 100%;
  }

  @media ${globals.mediaqueries.medium}{
    padding-bottom: 45%;
  }
`

export const BrandList = styled.ul`
  display:flex;
  list-style:none;
  max-width: 1000px;
  margin:0 auto;
  padding:0;
  justify-content: space-between;

  @media ${globals.mediaqueries.medium}{
    max-width:666px;
  }

  & > li {
    align-self:center;

    img {

      @media ${globals.mediaqueries.small}{
        width:80px;
        height:auto;
      }

      @media ${globals.mediaqueries.extraSmall}{
        width:50px;
        height:auto;
      }

      @media ${globals.mediaqueries.medium}{
        width:101px;
      }
    }
  }

`

export const TitleTiposDebitos = styled(H2)`
  margin-bottom: 20px !important;
`

export const SubtitleTiposDebitos = styled(H5)`
  text-align:center;
  color: #3a3864;
  font-weight: 300;
  line-height: 1.6;
  margin-bottom:40px;
`

export const TiposDeDebitos = styled.div`
  background:#f5f9fc;
  padding-bottom:80px;
  clip-path: polygon(100% 0%, 0% 0%, 0% 95%, 8% 93%, 18% 91%, 28% 90%, 41% 89%, 50% 89%, 59% 89%, 72% 90%, 82% 92%, 91% 95%, 100% 100%);

  & > div {
    margin-top:0;
  }

  h2 {
    margin-top:10px;
  }

  .etapa-title {

    @media ${globals.mediaqueries.medium}{
      max-width:100%;
    }

    @media ${globals.mediaqueries.large}{
      max-width:75%;
    }
  }

  .tipos-de-debitos {
    max-width:920px;

    /* breakpoint especifico para esse caso */
    @media screen and (max-width: 1350px){
      max-width:860px;
      grid-template-columns:repeat(auto-fit,minmax(350px,1fr));
      margin-left:0;
    }

    @media ${globals.mediaqueries.medium}{
      max-width:650px;
      grid-template-columns:repeat(auto-fit,minmax(260px,1fr));
    }
  }

  h2, h5 {
    /* breakpoint especifico para esse caso */
    @media screen and (max-width: 1350px){
      text-align:left;
    }

    @media ${globals.mediaqueries.extraSmall}, ${globals.mediaqueries.small}{
      text-align: center;
    }
  }

  h2 {

    @media ${globals.mediaqueries.extraSmall}, ${globals.mediaqueries.small}{
      padding-top:30px;
    }
  }
`

export const TiposDeDebitosWrapper = styled.div`
  position:relative;

  & > svg {
    width:100%;
    height:auto;
    display:block;
    z-index:0;
    position:relative;
  }

  .screen-right {
    position: absolute;
    right:0;
    bottom:-90px;
    z-index:50;

    @media ${globals.mediaqueries.extraSmall}, ${globals.mediaqueries.small}{
      display:none;
    }
  }

  .circle {

    /* breakpoint especifico para esse caso */
    @media screen and (max-width: 1350px){
      margin-left:0;
    }

    @media ${globals.mediaqueries.medium}{
      margin-left:0;
    }

    @media ${globals.mediaqueries.small}, ${globals.mediaqueries.extraSmall}{
      margin-left:auto;
    }
  }
`

export const NaoIndicadoWrapper = styled(Container)`
  display:grid;
  grid-template-columns: 185px minmax(0,1fr);
  grid-gap:35px;
  max-width:870px;

  @media ${globals.mediaqueries.extraSmall}{
    grid-template-columns: 1fr;
    grid-gap:15px;
  }

  @media ${globals.mediaqueries.small}{
    grid-template-columns: 110px minmax(0,1fr);
    grid-gap:15px;
  }
  
  img {

    @media ${globals.mediaqueries.extraSmall}{
      margin:0 auto;
      display:block;
    }
  }

  h2 {
    margin-top:0;
    padding-top:0;
    color: ${globals.colors.darkblue};

    @media ${globals.mediaqueries.small}{
      text-align:left;
    }
  }

  p {
    line-height:1.6;
    color: #3a3864;

    @media ${globals.mediaqueries.extraSmall}{
      text-align:center;
    }
  }
`

export const FaqImageWrapper = styled.div`
  display: block;
  text-align: center;
`

export const FaqTitleWrapper = styled.dt`
  padding-top:20px;
  padding-bottom:20px;
  
  & > * {
    display:flex !important;

    svg {
      margin-right:0;
      margin-left:auto;
      align-self:center;
    }
  }

  button {
    text-align:left;
    line-height:1.3;
    display:flex;

    svg {
    
      > * {
        fill: ${globals.colors.darkblue};
      }
    }

    h4 {
      text-align:left;
      padding-right:10px !important;
    }
  }
`

export const FaqItemWrapper = styled.div`
  text-align:left;
  border-bottom: 1px solid #cecece;
`

export const FaqItem = styled.dd`
  overflow:hidden;
  transition: max-height .4s ease;
  margin:0;
`

export const ArrowWrapper = styled.div`
  width:16px;
  display:block;
  transition: transform .2s;
  transform: ${props => props.isActive ? `rotate(180deg)` : ''};
  margin-right:0;
  margin-left:auto;
`